import { render, staticRenderFns } from "./PauseOverlay.vue?vue&type=template&id=aab8e3b8&scoped=true&"
import script from "./PauseOverlay.vue?vue&type=script&lang=js&"
export * from "./PauseOverlay.vue?vue&type=script&lang=js&"
import style0 from "./PauseOverlay.vue?vue&type=style&index=0&id=aab8e3b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab8e3b8",
  null
  
)

export default component.exports